export default __webpack_public_path__ + "static/media/BrainBreak cards98.a101a915.png";